import { Row } from '../grid';
export default Row;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/row/index.js
// module id = 665
// module chunks = 0